import React, {useContext, useEffect, useState} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import UIPopupContext from "../../popups/UIPopup/UIPopupContext";
import {getCurrentPrompts} from "../aiApi/aiApi";
import LoadingSpinner from "../../ui/loadingSpinner";
import {getAIInitialGroups} from "../aiFunctions";
import {getCurrentLayout} from "../../appLayout";
import {getAIGlobalSettings} from "../aiAsyncActions";
import UiPopupAIContentTabs, {AI_POPUP_TABS, AI_POPUP_TAB_IDS} from "./UiPopupAIContentTabs";
import UiPopupAIContentAIManagement from "./UiPopupAIContentAIManagement";
import UiPopupAIContentSqftAI from "./UiPopupAIContentSqftAI";


const UiPopupAIContent = (props) => {

  const {aiLoading, aiImportData, aiSettings, getAIGlobalSettings} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {userFile} = uiPopupContext;

  const [loading, setLoading] = useState(true);
  // the prompts / groups below are loaded once and shared by every tab, so switching tabs is
  // just swapping the rendered content - no refetch
  const [activeTab, setActiveTab] = useState(AI_POPUP_TABS[0].id);

  const checkIfButtonDisabled = () => {
    uiPopupDispatch({
      saveButtonDisabled: aiLoading ? false : !userFile, // unblock save button if file is uploaded from look ai, to stop it
    });
  }

  const setInitialAiLogic = async () => {
    setLoading(true);
    // `loading` starts as true, so anything throwing before setLoading(false) used to leave
    // the whole popup on the spinner with no content and no visible error - most commonly
    // getCurrentPrompts() when :7122/api/Prompt is unreachable.
    let aiResponses = [];
    try {
      aiResponses = await Promise.all([
        getCurrentPrompts(),
        getAIGlobalSettings()
      ]);
    } catch (e) {
      console.log("setInitialAiLogic: failed to load AI prompts / global settings", e);
    }
    setLoading(false);
    const newGroupObjects = getAIInitialGroups(aiImportData, aiSettings, true)
    const layout = getCurrentLayout();
    const allFeatureGroups = layout.getAllFeatureGroups();

    uiPopupDispatch({
      userFile: null,
      promptsList: aiResponses[0],
      saveButtonDisabled: true,
      groupObjects: newGroupObjects,
      showAllFeatureGroups: false,
      allFeatureGroups,
    });
    checkIfButtonDisabled();
  }

  useEffect(() => {
    setInitialAiLogic();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    checkIfButtonDisabled()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aiLoading]);

  const renderActiveTabContent = () => {
    switch (activeTab) {
      case AI_POPUP_TAB_IDS.sqftAiManagement:
        return <UiPopupAIContentSqftAI/>
      default:
        return <UiPopupAIContentAIManagement/>
    }
  }

  return (
    <div className="u-h-full u-w-full u-pl-075 u-pr-075 scrollable relative">
      {loading ? <LoadingSpinner size="smaller"/> : (
        <div>
          <UiPopupAIContentTabs activeTab={activeTab} onTabClick={setActiveTab}/>
          {renderActiveTabContent()}
        </div>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  const {aiLoading, aiImportData} = store.aiState;
  const {aiSettings} = store.fabricatorState;

  return {
    fabricatorData,
    aiLoading,
    aiSettings,
    aiImportData,
  };
};

const mapDispatchToProps = {
  getAIGlobalSettings,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(UiPopupAIContent)
)
